import { FetchQueryOptions, useQuery } from "@tanstack/react-query";

import { readDexSdk } from "../dex-sdk";

export interface GetDailyRestrictedMintsRemainingArgs {
  enabled?: boolean;
}

export function dailyRestrictedMintsRemainingQueryKey() {
  return ["dailyRestrictedMintsRemaining"] as const;
}

export function dailyRestrictedMintsRemainingQuery() {
  return {
    queryKey: dailyRestrictedMintsRemainingQueryKey(),
    queryFn: async () => {
      return await readDexSdk.mintsRemaining();
    },
  } satisfies FetchQueryOptions;
}

/**
 * Query to check how many restricted mints are remaining for the day.
 *
 * @remarks This query is temporary and only for use in testnet. The mints_remaining
 * view function is a testnet-only feature and should be removed before mainnet deployment.
 */
export function useDailyRestrictedMintsRemaining(args: GetDailyRestrictedMintsRemainingArgs) {
  return useQuery({
    ...dailyRestrictedMintsRemainingQuery(),
    enabled: args.enabled ?? true,
  });
}
